// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_o-1";
export var movingGradient = "_o-4";
export var movingGradientBlock = "_o-2";
export var skeleton = "_o-0";
export var skeletonText = "_o-3";